import comic0 from '../../img/comics/4PanelComic_1.png'
import comic1 from '../../img/comics/4PanelComic_2.png'
import comic2 from '../../img/comics/4PanelComic_3.png'
import comic3 from '../../img/comics/4PanelComic_4.png'
import comic4 from '../../img/comics/4PanelComic_Molly_1.png'
import comic5 from '../../img/comics/4PanelComic_Molly_2.png'
const AllComics = [
    {
        id: 0,
        Name: "The Question..",
        Img: comic0,
        Characters: [
            "JinxBunny", "MinxBunny",
        ],
        shortName: "thequestion",
    },
    {
        id: 1,
        Name: "It's on",
        Img: comic1,
        Characters: [
            "JinxBunny", "MinxBunny",
        ],
        shortName: "it'son",
    },
    {
        id: 2,
        Name: "Positivity",
        Img: comic2,
        Characters: [
            "JinxBunny", "MinxBunny", "Appa"
        ],
        shortName: "positivity",
    },
    {
        id: 3,
        Name: "Suprise",
        Img: comic3,
        Characters: [
            "JinxBunny", "MinxBunny"
        ],
        shortName: "suprise",
    },
    {
        id: 4,
        Name: "Skull 'n' a Shake",
        Img: comic4,
        Characters: [
            "Molly", "Dex"
        ],
        shortName: "skull'n'ashake",
    },
    {
        id: 5,
        Name: "Molly's Truth",
        Img: comic5,
        Characters: [
            "Molly", "Dex"
        ],
        shortName: "molly'struth",
    },
]

export default AllComics